import Slider from "react-slick";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import Avatar from "@mui/material/Avatar";
import { translate, t } from "react-multi-lang";
import { Facebook } from "react-content-loader";
import React, { useEffect, useState } from "react";

import { fetchPostSuggesstionStart } from "../../store/actions/HomeAction";
import {
  isNotVerified,
  isPendingVerification,
} from "../../helpers/storage/user";
import Location from "../common/Location";
import { useRef } from "react";

const HomePageSuggesstion = (props) => {
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    vertical: true,
    verticalSwiping: false,
    swipeToSlide: true,
    speed: 500,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          vertical: true,
          verticalSwiping: false,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          vertical: true,
          verticalSwiping: false,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          vertical: false,
          verticalSwiping: false,
          dots: true,
        },
      },
    ],
  };

  const suggestionBoxRef = useRef(null)

  useEffect(() => {
    props.dispatch(fetchPostSuggesstionStart());
  }, []);

  const [scroll, setScroll] = useState(false);
  const [scrollTop,setScrollTop] = useState({})
  const [containerHeight, setContainerHeight] = useState(0);

  useEffect(() => {
    const containerElement = document.getElementById('alerts-container');
    if (containerElement) {
      const height = containerElement.offsetHeight;
      setContainerHeight(height);
    }
  }, []);
  
  useEffect(() => {
    let temp = suggestionBoxRef?.current?.getBoundingClientRect().top
    temp = temp ? temp+80 : 70
    let scroll = () => {
      setScroll(window.scrollY >= temp);
      if (window.scrollY <= containerHeight) {
        setScrollTop({});
      } else if (temp > window.scrollY) {
        setScrollTop({ top: temp + 'px' });
      } else {
        setScrollTop({});
      }      
    };
    window.addEventListener("scroll", scroll);
    return () => {
      window.removeEventListener("scroll", scroll);
    };
  }, [containerHeight]);

  const isVerified =
    isNotVerified() || isPendingVerification() ? "top_suggest" : "";

    const styles = props.userNotFound ? props.bookmarkStyle : { ...props.bookmarkStyle, ...scrollTop };

  return (
    <Col
      xl={4}
      md={12}
      sm={12}
      className= {`${props.userNotFound ? "error-suggestions mt-5 px-5" : `suggest-col mt-3 ${scroll ? "top_suggest_padding" : ""} ${isVerified}`}`} 
      style={styles}
      ref={suggestionBoxRef}
    >
      <Row>
        <Col sm={12} xl={5} xs={12} md={6} className="mrg-btm-xs">
          <h4 className="suggestions">
            <b>{t("suggestions")}</b>
          </h4>
        </Col>
        <Col sm={12} xl={7} xs={12} md={6} className="mrg-btm-xs"></Col>
        <Col sm={12} xl={12} xs={12} md={12}>
          <div>
            <div className="suggestion-slider">
              <div className="item active">
                <Row className="diplay-block mt-3">
                  <Col>
                    {props.postSug.loading ? (
                      <>
                        <Facebook />
                        <Facebook />
                        <Facebook />
                      </>
                    ) : props.postSug.data.users.length > 0 ? (
                      <Slider {...settings}>
                        {props.postSug.data.users.map((user, ind) => (
                          <div className="col-item" key={ind}>
                            <div className="photo">
                              <div className="swiper-slide">
                                <div className="b-friend">
                                  <a
                                    aria-label='navigate to user profile'
                                    href={`/user/${encodeURIComponent(user?.username?.toLowerCase())}`}
                                    id="user_suggestion_link"
                                  >
                                    <div
                                      className=" mb-2 cover-img b-friend__content d-flex align-items-center"
                                      style={{
                                        backgroundImage: `url(${user.cover})`,
                                        backgroundPosition: "center",
                                        backgroundSize: "cover",
                                        backgroundRepeat: "no-repeat",
                                        padding: "20px",
                                        borderRadius: "7px",
                                      }}
                                    >
                                      {/* profile image */}
                                      <div
                                        className="avatar"
                                        style={{ margin: "0 10px" }}
                                      >
                                        <Avatar
                                          src={user.picture}
                                          style={{
                                            width: "80px",
                                            height: "80px",
                                          }}
                                          className="border border-danger user-image img-fluid"
                                          alt='avtar'
                                        />
                                      </div>
                                      <div className="name">
                                        {/* name  */}
                                        <div className="b-name-row">
                                          {user.name}{" "}
                                        </div>
                                        {/* user name  */}
                                        <div className="b-username-row">
                                          {/* @{user.username} */}
                                          <Location 
                                            city={user?.city} 
                                            country={user?.country} 
                                            is_traveling={user?.is_traveling}
                                            traveling_location={user?.traveling_location}
                                            color="#fff" 
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </Slider>
                    ) : (
                      <span>{t("no_suggestions")}</span>
                    )}
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Col>
  );
};

const mapStateToPros = (state) => ({
  postSug: state.home.postSug,
  profile: state.users.profile,
});

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToPros,
  mapDispatchToProps
)(translate(HomePageSuggesstion));
